let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hTQcB")).then(() => parcelRequire('gJmPi'));